module.exports = __webpack_public_path__ + "assets/img/user_TYP.eef2efc6.jpg";